/** Persisted open/collapsed state of the left content aside (desktop collapse). */
export const LEFT_ASIDE_OPEN_STORAGE_KEY = 'rtu-left-aside-open'

export const readStoredIsOpenSidebarMenu = (): boolean => {
  if (typeof localStorage === 'undefined') return true
  try {
    const raw = localStorage.getItem(LEFT_ASIDE_OPEN_STORAGE_KEY)
    if (raw === null) return true
    return raw === 'true'
  } catch {
    return true
  }
}

export const persistIsOpenSidebarMenu = (isOpen: boolean) => {
  if (typeof localStorage === 'undefined') return
  try {
    localStorage.setItem(LEFT_ASIDE_OPEN_STORAGE_KEY, String(isOpen))
  } catch (error) {
    console.error('Failed to persist left aside open state', error)
  }
}
